export function ellipsis(text: string, len = 25) {
    if (text === null) { return '' }
    return text.substring(0, len) + ((text.length > len) ? '...' : '')
}
